import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaxtonCardsListComponent } from './caxton-cards-list/caxton-cards-list.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { CaxtonCardActionSelectorComponent } from "./caxton-card-action-selector/caxton-card-action-selector.component";
import { CaxtonCardBulkUpdateModalComponent } from "./caxton-card-bulk-update-modal/caxton-card-bulk-update-modal.component";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    CaxtonCardsListComponent,
    CaxtonCardActionSelectorComponent,
    CaxtonCardBulkUpdateModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule
  ]
})
export class CardTrackerModule { }
